import { InLifeHeader } from '@in-life/components/Header';

import { Layout, LayoutProps } from '@components/Layout';

const InLifeLayout = ({ children, ...props }: LayoutProps) => (
  <Layout HeaderComponent={InLifeHeader} {...props} hideSignupStartAgainDialog>
    {children}
  </Layout>
);

export { InLifeLayout };
